import React from "react";
import Html from "utils/Html";
import FilterNotifyType from "components/notify/features/topfilter/filter.notifytype";
import FilterCountry from "components/notify/features/topfilter/filter.country";
import FilterDepartment from "components/notify/features/topfilter/filter.department";
import FilterSearch from "components/notify/features/topfilter/filter.search";
import BtnSearch from "components/notify/features/topfilter/btn.search";
import BtnClear from "components/notify/features/topfilter/btn.clear";
import { useNotify } from "context/NotifyContext";

export default function TopContent({ userData }) {
  const { filters, filterData } = useNotify();
  if (!("user_sess" in userData)) {
    return <Html.NoAccess />;
  }
  if (filterData.err === 1) {
    return <div>Fetch request error: {filterData.err_msg}</div>;
  } else if (filterData.data === "") {
    return "";
  }
  return (
    <div id="top-content">
      <form
        key={"form-filter" + filters.key_form}
        id="form-filter"
        className="row"
        method="post"
      >
        <div className="col s12">
          <div
            className="row"
            style={{ marginTop: "10px", marginBottom: "0px" }}
          >
            <div className="col s4">
              <FilterNotifyType data={filterData.data.email_recips} />
            </div>
            <div className="col s4">
              <FilterCountry data={filterData.data.countries} />
            </div>
            <div className="col s4">
              <FilterDepartment data={filterData.data.departments} />
            </div>
          </div>
        </div>
        <div className="col s12">
          <div
            className="row"
            style={{ marginTop: "0px", marginBottom: "10px" }}
          >
            <div className="col s4">
              <FilterSearch />
            </div>
            <div className="col s8" style={{ paddingTop: "30px" }}>
              <BtnClear />
              <BtnSearch />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}
